<template>
  <div v-frag class="fadeIn">
    <CardIeaAppMain>
      <v-container fluid class="pa-4">
        <!-- HEADER -->
        <v-row align="center" class="mb-6">
          <v-col cols="12">
            <h1 class="text-h4 font-weight-bold bce-text-gradient">Materias Pendientes</h1>
            <p class="grey--text text--darken-1">Visualiza las asignaturas restantes para completar tu plan de estudios y alcanzar tu meta académica.</p>
          </v-col>
        </v-row>

        <div v-if="loading" class="text-center pa-10">
          <v-progress-circular indeterminate color="#E50050" size="48"></v-progress-circular>
          <div class="mt-4 grey--text">Analizando tu situación académica...</div>
        </div>

        <div v-else>
          <v-card class="rounded-xl overflow-hidden elevation-3 border-light">
            <v-simple-table class="bce-premium-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left font-weight-bold grey--text text--darken-2">Materia por Finalizar / Pendiente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(itemTableData, keyItemTableData) in filteredData" :key="keyItemTableData" class="bce-tr-hover">
                    <td class="py-5 px-6">
                      <div class="d-flex align-center">
                        <v-avatar color="red lighten-5" size="40" class="mr-4">
                          <v-icon color="#E50050" small>mdi-book-clock-outline</v-icon>
                        </v-avatar>
                        <div>
                          <div class="text-h6 font-weight-bold grey--text text--darken-4">{{ itemTableData.catedra }}</div>
                          <div class="text-caption bce-red-text font-weight-medium">Pendiente de aprobación</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <!-- EMPTY STATE / SUCCESS -->
          <v-alert
            v-if="filteredData.length === 0"
            border="left"
            colored-border
            color="success"
            elevation="2"
            class="rounded-xl mt-6 pb-4"
          >
            <div class="d-flex align-center">
              <v-icon color="success" class="mr-3" large>mdi-check-decagram</v-icon>
              <div>
                <div class="text-subtitle-1 font-weight-bold">¡Felicidades!</div>
                <div class="text-body-2">Has completado todas las materias de tu plan de estudios o no hay pendientes registradas actualmente.</div>
              </div>
            </div>
          </v-alert>
          
          <div class="mt-8 d-flex justify-center">
            <v-btn text color="grey darken-1" @click="$router.push({name: 'Home'})" class="text-none">
              <v-icon left>mdi-arrow-left</v-icon> Volver al inicio
            </v-btn>
          </div>
        </div>
      </v-container>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain.vue";

export default {
  name: "MateriasFaltantes",
  components: { CardIeaAppMain },
  data: () => ({ 
    data: [], 
    loading: true 
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    filteredData() {
      return this.data;
    }
  },
  mounted() { 
    this.MateriasFaltan(); 
  },
  methods: {
    async MateriasFaltan() {
      this.loading = true;
      try {
        const res = await this.$API.post({ 
          url: "examenes/v2/showCursoIea", 
          data: { alumno: this.user.IDStB } 
        });
        
        let cursos = res.data;
        let uniqueMaterias = [];

        if (cursos && Array.isArray(cursos)) {
          cursos.forEach(planestudio => {
            if (planestudio.plan_de_estudio_v2 && planestudio.plan_de_estudio_v2.length !== 0) {
              const materias = planestudio.plan_de_estudio_v2.filter(materia => {
                // Same logic as iea-public for identifying missing subjects
                return materia.aprobada === false || 
                       materia.examen_inscipcion_alumno == null || 
                       materia.examen_inscipcion_alumno.notas.length == 0 || 
                       materia.examen_inscipcion_alumno.notas[3].nota < 4;
              });

              materias.forEach(m => {
                if (!uniqueMaterias.find(um => um.catedra === m.catedra)) {
                  uniqueMaterias.push(m);
                }
              });
            }
          });
        }
        this.data = uniqueMaterias;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.bce-text-gradient {
  background: linear-gradient(45deg, #1a237e 30%, #E50050 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bce-red-text {
  color: #E50050;
}

.border-light {
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.bce-premium-table thead th {
  background-color: #f8f9fa !important;
  height: 50px !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.5px;
}

.bce-tr-hover:hover {
  background-color: #fffafa;
}

.fadeIn { 
  animation: fadeIn 0.4s ease-in-out; 
}

@keyframes fadeIn { 
  from { opacity: 0; transform: translateY(10px); } 
  to { opacity: 1; transform: translateY(0); } 
}
</style>
